const offlineShellEnabled = (
  process.env.NODE_ENV === 'production'
  || process.env.REACT_APP_OFFLINE_SHELL_ENABLED === 'true'
);

function isMindmappiWorker(registration) {
  const worker = registration.active || registration.waiting || registration.installing;
  if (!worker?.scriptURL) return false;

  try {
    return new URL(worker.scriptURL).pathname === '/service-worker.js';
  } catch {
    return false;
  }
}

export async function configureOfflineShell() {
  if (!('serviceWorker' in navigator)) return null;

  if (!offlineShellEnabled) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations
      .filter(isMindmappiWorker)
      .map((registration) => registration.unregister().catch(() => false)));
    return null;
  }

  const registration = await navigator.serviceWorker.register('/service-worker.js', {
    scope: '/',
  });
  registration.update().catch(() => {});
  return registration;
}

export { isMindmappiWorker, offlineShellEnabled };
